import { render, staticRenderFns } from "./SaldoContabil.vue?vue&type=template&id=3453bf07"
import script from "./SaldoContabil.vue?vue&type=script&lang=js"
export * from "./SaldoContabil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports